import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PasswordModule } from 'primeng/password';
import { take } from 'rxjs';
import { PublicLinkService } from 'app/hub-components/services/public-link/public-link.service';
import { TrackingService } from 'app/hub-components/services/tracking/tracking.service';

@Component({
  standalone: true,
  selector: 'password-prompt',
  templateUrl: './password-prompt.component.html',
  styleUrls: ['./password-prompt.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    PasswordModule,
    ButtonModule,
  ],
})
export class PasswordPromptComponent {
  public password: string = '';
  public errorMessage: string = '';
  public verifyingPassword: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private publicLinkService: PublicLinkService,
    private trackingService: TrackingService,
  ) {}

  public submit(): void {
    if (!this.password || this.password.trim() === '') {
      this.errorMessage = 'Password is required';
      return;
    }

    this.trackingService.track('Verify password for public link', { uuid: this.config.data.uuid });
    this.verifyingPassword = true;
    this.publicLinkService.verifyPassword(this.config.data.uuid, this.password).pipe(
      take(1),
    ).subscribe(result => {
      this.verifyingPassword = false;
      if (result.success) {
        this.ref.close(this.password);
      } else {
        this.errorMessage = 'Please enter the correct password';
      }
    });
  }
}
